import { Link, ShieldCheck, SlidersHorizontal } from "lucide-react";
import { MmcFrame } from "../../admin-framework/MmcFrame.js";
import type { SimulatorAppSurfaceProps } from "../AppSurface.js";

export function GroupPolicyApp({ activeMachine, app, onRunCommand }: SimulatorAppSurfaceProps) {
  const run = (commandType: string, capability: string, label: string, payload: Record<string, unknown>) => {
    void onRunCommand({ appId: app.id, capability, commandType, label, payload: { machineId: activeMachine, ...payload } });
  };

  return (
    <div className="fd-sim-app fd-sim-admin-tool">
      <MmcFrame
        title={app.title}
        actions={[
          { label: "New GPO", onClick: () => run("GPO_CREATE", "policy.gpo.write", "New GPO", { gpoName: "FD-Hardening-154" }) },
          { label: "Link", onClick: () => run("GPO_LINK_OU", "policy.gpo.link.write", "Link GPO", { gpoName: "FD-Hardening-154", ouName: "ServiceDesk" }) },
          { label: "Edit", onClick: () => run("GPO_SET_SETTING", "policy.gpo.setting.write", "Edit Setting", { gpoName: "FD-Hardening-154", settingPath: "Computer Configuration\\Policies\\Security Options", value: "Enabled" }) },
          { label: "Enforce", onClick: () => run("GPO_ENFORCE_LINK", "policy.gpo.link.write", "Enforce Link", { enforced: true, gpoName: "FD-Hardening-154", ouName: "ServiceDesk" }) }
        ]}
        columns={[
          { key: "name", label: "GPO" },
          { key: "linked", label: "Linked to" },
          { key: "status", label: "Status" }
        ]}
        rows={[
          { id: "default", values: { name: "Default Domain Policy", linked: "domain", status: "Enforced" }, onDoubleClick: () => run("GPO_SET_SETTING", "policy.gpo.setting.write", "Edit Setting", { gpoName: "Default Domain Policy", settingPath: "Account Policies", value: "Enabled" }) },
          { id: "hardening", values: { name: "FD-Hardening-154", linked: "ServiceDesk", status: "Enabled" }, onDoubleClick: () => run("GPO_LINK_OU", "policy.gpo.link.write", "Link GPO", { gpoName: "FD-Hardening-154", ouName: "ServiceDesk" }) }
        ]}
        tree={[
          { active: true, id: "forest", icon: <ShieldCheck size={16} />, label: "Forest: advanced-ti.local" },
          { id: "domain", icon: <Link size={16} />, label: "advanced-ti.local" },
          { active: true, id: "gpos", icon: <SlidersHorizontal size={16} />, label: "Group Policy Objects" }
        ]}
      >
        <section className="fd-mmc-property-band">
          <button type="button" onClick={() => run("GPO_BLOCK_INHERITANCE", "policy.gpo.link.write", "Block inheritance", { blocked: true, ouName: "ServiceDesk" })}>Block inheritance</button>
          <button type="button" onClick={() => run("GPO_UNLINK_OU", "policy.gpo.link.write", "Unlink GPO", { gpoName: "FD-Hardening-154", ouName: "ServiceDesk" })}>Unlink</button>
        </section>
      </MmcFrame>
    </div>
  );
}
